import React from 'react';
import {useQuery} from "react-query";
import ngage from "services/ngage";
import StatList from "components/StatList";
import StatBoxSimple from "components/StatBoxSimple";
import {formattedDate, secondsToHuman} from "services/date";
import Card from "components/Card";
import {useOperator} from "context/OperatorContext";
import {UserInsights} from "types/User";
import {Visit} from "../../../types/Visit";

// Types ----

type VisitsCardProps = {
  userId: number
  insights?: UserInsights | null
}

// Component ----

function VisitsCard({userId, insights}: VisitsCardProps) {
  const {termFor} = useOperator();

  const {data: visits, isLoading: isLoadingVisits} = useQuery(
    ['visits.all', {visitors: userId}],
    () => ngage.visits.filtered({visitors: userId}),
    {keepPreviousData: true}
  )

  const latestVisitId = visits?.data[0]?.id;

  const {data: visit, isLoading: isLoadingVisit} = useQuery(
    ['visits.all', latestVisitId],
    () => ngage.visits.get(Number(latestVisitId)),
    {keepPreviousData: true, enabled: !!latestVisitId}
  )

  return (
    <Card heading={termFor('Visits')} isLoading={isLoadingVisits || isLoadingVisit}>
      <StatList columns={2}>
        <StatBoxSimple
          name='Total'
          stat={insights?.engagement.all_visits}
        />
        <StatBoxSimple
          name='Time on site'
          stat={secondsToHuman(insights?.engagement.total_visit_duration ?? 0)}
        />
        <StatBoxSimple
          name='Average time on site'
          stat={secondsToHuman(insights?.engagement.visit_duration ?? 0)}
        />
        <StatBoxSimple
          name={`Last ${termFor('Visit')}`}
          stat={formattedDate(insights?.engagement.last_visit_date) ?? 'Never'}
        />
      </StatList>

      {/* TODO: Reinstate when we know how to display beacon/qr code "activity/interactions/activations" */}
      {/*{!!visit &&*/}
      {/*  <div className="mt-10 flow-root">*/}
      {/*    {!insights?.engagement.last_visit_date ? (*/}
      {/*      <>*/}
      {/*        <Divider/>*/}
      {/*        <p className="text-sm text-gray-400 mt-6">No {termFor('visits')}</p>*/}
      {/*      </>*/}
      {/*    ) : (*/}
      {/*      <>*/}
      {/*        <Divider label={`Last ${termFor('visit')} - ${formattedDate(insights?.engagement.last_visit_date)}`}/>*/}

      {/*        <div className="mt-6">*/}
      {/*          <VisitActivityFeed visit={visit}/>*/}
      {/*        </div>*/}
      {/*      </>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*}*/}
    </Card>
  );
}

// Export ----

export default VisitsCard;